export type SupportedLanguage = 'en' | 'ru' | 'cs';

export const SUPPORTED_LANGUAGES: SupportedLanguage[] = ['en', 'ru', 'cs'];

export function isSupportedLanguage(value: string | null | undefined): value is SupportedLanguage {
    return (SUPPORTED_LANGUAGES as string[]).includes(value ?? '');
}

export function mapTelegramLanguageCode(code: string | null | undefined): SupportedLanguage | null {
    const primary = code?.split('-')[0]?.toLowerCase();
    return isSupportedLanguage(primary) ? primary : null;
}

export function resolveLanguage(params: { backendLanguageCode?: string | null; telegramLanguageCode?: string | null }): SupportedLanguage {
    const backend = params.backendLanguageCode?.toLowerCase();
    if (isSupportedLanguage(backend)) return backend;
    return mapTelegramLanguageCode(params.telegramLanguageCode) ?? 'en';
}

const INTL_LOCALE_BY_LANGUAGE: Record<SupportedLanguage, string> = { en: 'en-US', ru: 'ru-RU', cs: 'cs-CZ' };

export function intlLocaleForLanguage(language: string | null | undefined): string {
    return isSupportedLanguage(language) ? INTL_LOCALE_BY_LANGUAGE[language] : INTL_LOCALE_BY_LANGUAGE.en;
}
